

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import { CaseAction, TemplateDetails } from "@/types"

// @ts-ignore
import draggable from "vuedraggable"

@Component({
	components: {
		draggable
	}
})
export default class TemplateActionSetup extends Vue {
	@Prop()
	public template!: TemplateDetails

	@Prop({ type: Boolean, default: true })
	public canEdit!: boolean;

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	public get columns () {
		return [
			{
				key: "handle",
				label: ""
			},
			{
				key: "title",
				label: "Title"
			},
			{
				key: "requiredRecord",
				label: "Required on " + this.getRecordName
			},
			{
				key: "requiredCase",
				label: "Required on " + this.getCaseName
			},
			{
				key: "buttons",
				label: ""
			}
		]
	}

	public get dragOptions () {
		return {
			animation: 200,
			group: "actions",
			disabled: false,
			ghostClass: "ghost"
		}
	}

	public addAction () {
		this.$emit("addAction")
	}

	public removeAction (item: CaseAction) {
		if (!this.template) {
			return
		}

		this.template!.actions.removeWhere(a => a === item)
	}
}

